import * as React from "react"
import { 
  Edit
} from "react-admin"

import { transformProduct } from "../utils/transformProduct";
import ClothesForm from "./ClothesForm"

const ClothesTitle = () => {
  return <span>{'衣服商品'}</span>;
};

const ClothesEdit = () => {
  return (
    <Edit 
      title={<ClothesTitle/>} 
      redirect={false} 
      mutationMode="optimistic" 
      transform={transformProduct}
    >
      <ClothesForm />
    </Edit>
  )
}

export default ClothesEdit